import { useEffect } from 'react';
import { PRIORITY_OPTIONS, STATUS_OPTIONS } from '../../constants/statusConfig';

/**
 * Custom hook for managing status information (priority, status, deadline)
 * @param {Object} entity - The entity (literary group, book, character, variation) to manage status for
 * @param {Object} formikRef - Reference to the Formik form
 * @returns {Object} - Status management functions and state
 */
const useStatusManagement = (entity, formikRef) => {
  // Initialize Formik values when entity changes
  // useEffect(() => {
  //   if (entity && formikRef?.current) {
  //     // Read from entity.profile (correct architecture - all form data is in profile)
  //     formikRef.current.setFieldValue('priority', entity.profile?.priority || 'medium');
  //     formikRef.current.setFieldValue('status', entity.profile?.status || 'not-started');
  //     formikRef.current.setFieldValue('deadline', entity.profile?.deadline || null);
  //   }
  // }, [entity, formikRef]);

  // Function to get color for priority
  const getPriorityColor = (priorityValue) => {
    switch (priorityValue) {
      case 'high':
        return 'red';
      case 'medium':
        return 'orange';
      case 'low':
        return 'green';
      case 'urgent':
        return 'red';
      default:
        return 'grey';
    }
  };

  // Function to get color for status
  const getStatusColor = (statusValue) => {
    switch (statusValue) {
      case 'new':
        return 'blue';
      case 'not-started':
        return 'blue';
      case 'in-progress':
        return 'yellow';
      case 'review':
        return 'purple';
      case 'completed':
        return 'green';
      default:
        return 'grey';
    }
  };
  const statusMsgs = [
    { group: 'SUCCESS_STATUS', msgKey: 'VARIATION_CREATED', msg: 'Variation created successfully! You can now record voice for this variation.' },
    { group: 'PLAYER_INFO', msgKey: 'VARIATION_CREATED', msg: `Audio Variation - available. Duration: {duration}` },
    { group: 'PLAYER_INFO', msgKey: 'VARIATION_NOT_RECORDED', msg: 'Voice not recorded for this variation' },
  ]

  // Check if deadline is approaching or past
  const isDeadlineApproaching = () => {
    const deadline = formikRef?.current?.values?.deadline;
    if (!deadline) return false;

    const deadlineDate = new Date(deadline);
    const now = new Date();
    const diffDays = Math.ceil((deadlineDate - now) / (1000 * 60 * 60 * 24));

    return diffDays <= 7 && diffDays > 0;
  };

  const isDeadlinePast = () => {
    const deadline = formikRef?.current?.values?.deadline;
    if (!deadline) return false;

    const deadlineDate = new Date(deadline);
    const now = new Date();

    return deadlineDate < now;
  };

  // Get deadline warning message
  const getDeadlineWarning = () => {
    if (isDeadlinePast()) {
      return 'Deadline has passed!';
    } else if (isDeadlineApproaching()) {
      return 'Deadline is approaching!';
    }
    return null;
  };

  return {
    // Setters that update Formik values
    setPriority: (value) => formikRef?.current?.setFieldValue('priority', value),
    setStatus: (value) => formikRef?.current?.setFieldValue('status', value),
    setDeadline: (value) => formikRef?.current?.setFieldValue('deadline', value),

    // Getters that read from Formik values
    get priority() { return formikRef?.current?.values?.priority || 'medium'; },
    get status() { return formikRef?.current?.values?.status || 'not-started'; },
    get deadline() { return formikRef?.current?.values?.deadline || null; },

    // Options
    priorityOptions: PRIORITY_OPTIONS,
    statusOptions: STATUS_OPTIONS,

    // Helper functions
    getPriorityColor,
    getStatusColor,
    isDeadlineApproaching,
    isDeadlinePast,
    getDeadlineWarning,
    statusMsgs
  };
};

export default useStatusManagement;
